import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { until } from 'lit/directives/until.js';
import { importElement } from '@cigna/cigna_csg_gsg_cipublic-bundle/lib/lazy.js';
import { FetchMixin } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/fetch.js';
import styles from './shared-content-wrapper.scss.js';
// extract html tag name from string
const extractTagNames = (elementHtml) => {
    const pattern = /<((?:\w+-)+\w+)/g; // all tags that include a hyphen
    return [...elementHtml.matchAll(pattern)].map((match) => match[1]).filter(Boolean);
};
/**
 * @element cipublic-shared-content-wrapper
 */
export class SharedContentWrapper extends FetchMixin(CipublicElement) {
    static get styles() {
        return [styles];
    }
    async renderComponents() {
        let components = [];
        try {
            components = (await this._fetchData());
            const tagsToImport = components.map((component) => extractTagNames(component.html)).flat();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            await Promise.all([...new Set(tagsToImport)].map((tagName) => importElement(tagName)));
            return html `${components.map((component) => unsafeHTML(component.html))}`;
        }
        catch (error) {
            return html `<slot name="error"></slot>`;
        }
    }
    render() {
        return html `${until(this.renderComponents(), html `<slot name="loading"></slot>`)}`;
    }
}
__decorate([
    property({ reflect: true })
], SharedContentWrapper.prototype, "src", void 0);
//# sourceMappingURL=shared-content-wrapper.js.map